


























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Insertion {
    legalInvoicingPeriodCompliance: boolean | null;
    proofReceptionDate: string | null;
    commissionInvoiceDate: string | null;
}

@Component({ components: { SimpleText } })
export default class PaymentPeriod extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.legalInvoicingPeriodCompliance",
            "insertion.proofReceptionDate",
            "insertion.commissionInvoiceDate",
        ];
    }

    public get colorIcon(): string {
        if (true === this.insertion.legalInvoicingPeriodCompliance) {
            return "success-pastel";
        } else if (false === this.insertion.legalInvoicingPeriodCompliance) {
            return "error-pastel";
        }
        return "info-pastel";
    }
}
